module.exports = "/_next/static/images/arrow-up-100fd80c3637eeb9e2a4423d301372e6.png";